import { RootComponentInstance } from "@uniformdev/canvas";
import { UniformEntryPage } from "src/pages/uniform-entry/uniform-entry-page";
import { useWAEContext } from "src/uniform/utils/wae-context-provider";

import FeatureGates from "@atlaskit/feature-gate-js-client";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { useLoggedInHasJira } from "@/components/user-context";
import { IntercomProvider } from "@/libraries/intercom/src";
import { LoggedInHeroContainer } from "@/templates/software/jira/logged-in/organic-logged-in/logged-in-hero-container";
import { OrganicLoggedInJiraProductTourOverview } from "@/templates/software/jira/logged-in/organic-logged-in/organic-logged-in-jira-product-tour-overview.template";
import { LoggedOutOrNoJiraProductTourOverview } from "@/templates/software/jira/logged-out/jira-software-logged-out-page/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const JiraSoftwarePage = () => {
    const loggedInHasJira = useLoggedInHasJira();
    const loggedInSkeletonEnabled = checkFeatureFlagGate(
        featureFlags.jfindLoggedInJiraProductTourSkeleton
    );

    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsw"
    );

    const isWae = checkFeatureFlagGate(
        featureFlags.dxpMigrationJiraProductTourGate
    );

    const template = loggedInHasJira ? (
        <OrganicLoggedInJiraProductTourOverview />
    ) : isWae ? (
        <WaeJiraPage />
    ) : (
        <LoggedOutOrNoJiraProductTourOverview />
    );

    return (
        <UFOSegment name="jira-product-tour-overview">
            <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
                <CrossFlowTouchpointProvider
                    productKeys={[ProductKeys.JIRA_SOFTWARE]}
                    screenName="wacJswProductTourPage"
                >
                    {loggedInSkeletonEnabled ? ( //Feature Gate checks for logged in users
                        <LoggedInHeroContainer>
                            {template}
                        </LoggedInHeroContainer>
                    ) : (
                        template
                    )}
                </CrossFlowTouchpointProvider>
            </IntercomProvider>
        </UFOSegment>
    );
};

const WaeJiraPage = () => {
    const { composition } = useWAEContext();

    return (
        <UniformEntryPage composition={composition as RootComponentInstance} />
    );
};
